export const FETCH_PROJECT_TEMPLATES_REQUEST =
  'FETCH_PROJECT_TEMPLATES_REQUEST';
export const FETCH_PROJECT_TEMPLATES_SUCCESS =
  'FETCH_PROJECT_TEMPLATES_SUCCESS';
export const FETCH_PROJECT_TEMPLATES_ERROR = 'FETCH_PROJECT_TEMPLATES_ERROR';
